const AuctionWatch = ({
    authed, 
    regType,
    auction, 
    auctionwatch_loading, 
    toggleAuctionWatch,
}) => {
    //const { authed = false, reg_type } = user
    const { watchlist = false } = auction.user || {};

    // Must be auction buyer to display auction watch
    if (!authed || regType != 2) {
        return null;
    }

    let icon = 'fa-plus-circle';
    let text = 'AuctionWatch';
    let wrapper_class = 'add';

    if (watchlist) {
        icon = 'fa-minus-circle';
        text = 'Remove from AuctionWatch';
        wrapper_class = 'remove';
    }

    if (auctionwatch_loading) {
        icon = 'fa-spin fa-spinner';
        text = ' Updating';
        wrapper_class = 'add saving';
    }

    return (
        <div 
            id="auction-details-auction-watch-toggle" 
            className={`auction-watch ${wrapper_class}`}
            onClick={toggleAuctionWatch}
        >
            <div className="icon">
                <i className={`fa fa-2x ${icon}`}/>
            </div>
            <div className="instruction">
                {' '}
                {text}
            </div>
        </div>
    );
};

export default AuctionWatch;